import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { FlavorProvider } from './flavor';

/*
  Generated class for the FlavorProvider provider.

  See https://angular.io/guide/dependency-injection for more info on providers
  and Angular DI.
*/


@Injectable({
    providedIn: 'root'
})
export class FlavorProviderSearch extends FlavorProvider {

  constructor(public http: HttpClient, public translateService: TranslateService) {
    super(http, translateService);
  }
}
